import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const PinIcon: React.ForwardRefExoticComponent<SvgIconProps> = React.forwardRef(
  (props: SvgIconProps, ref) => (
    <SvgIcon {...props} ref={ref}>
      <>
        <g>
          <rect fill="none" height="24" width="24" />
        </g>
        <g>
          <path
            d="M16,9V4l2,0V2H6v2l2,0v5c0,1.66-1.34,3-3,3h0v2h5.97v7l1,1l1-1v-7H19v-2h0 C17.34,12,16,10.66,16,9z"
            fillRule="evenodd"
          />
        </g>
      </>
    </SvgIcon>
  )
);

PinIcon.displayName = 'PinIcon';
